import axios from '~/utils/axios';

export const redirectToCognitoLogout = async (): Promise<void> => {
  try {
    const response = await axios.get('/auth/cognito/logout-url');
    const url: string | undefined = response?.data?.url;

    if (!url) {
      console.error('Cognito logout URL not provided by API response');
      return;
    }

    const TMB = process.env.TRUST_ME_BRO;
    window.location.href = TMB ? '/' : url;
  } catch (error) {
    console.error('Unable to resolve Cognito login URL', error);
  }
};
